module.exports = __webpack_public_path__ + "img/综合天气.b455c2ba.png";